import { createFileRoute } from "@tanstack/react-router";
import { SummaryView } from "@/components/Exercises/PersonalSources/SummaryView.tsx";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/personal-sources/summary/$sessionId",
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "Personal Sources Summary - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "personalSources.summary.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const params = Route.useParams();
  return <SummaryView audience="adults" sessionId={params.sessionId} />;
}
